<template>
  <nav aria-label="Page pagination" class="pagination_list">
    <ul v-if="pagination_length" class="justify-content-end">
      <pagination-item
        v-if="prev_link && getIsMobile"
        text="&lt;&lt;"
        :href="prev_link.url"
        :class="{active: prev_link.active}"
        @click="pageChange(1)"
        class="pagination_list__to_start_end"
        key="pagination-item__start"
      />
      <pagination-item
        v-if="prev_link"
        text="&lt;"
        :href="prev_link.url"
        :class="{active: prev_link.active}"
        @click="pageChange(active_page - 1)"
        key="pagination-item__prev"
      />
      <pagination-item
        v-for="(item, index) in get_pagination"
        :class="{active: item.active, disabled: !item.url}"
        :href="item.active ? '' : item.url"
        :text="item.label"
        @click="fetchData(item)"
        class="hidden_mobile"
        :key="`pagination-item__${index}`"/>
      <pagination-item
        v-if="next_link"
        text="&gt;"
        :href="next_link.url"
        :class="{active: next_link.active}"
        @click="pageChange(active_page + 1)"
        key="pagination-item__next"
      />
      <pagination-item
        v-if="next_link && getIsMobile"
        text="&gt;&gt;"
        :href="next_link.url"
        :class="{active: next_link.active}"
        @click="pageChange(get_pagination.length)"
        class="pagination_list__to_start_end"
        key="pagination-item__end"
      />
    </ul>
  </nav>
</template>

<script>

import {getQueryObj} from "../../../helpers/query_helper";
import PaginationItem from "./PaginationItem.vue";
import {mapGetters} from "vuex";

export default {
  name: "PaginationList",
  components: {PaginationItem},
  props: {
    pagination: {
      type: Array,
      default: () => []
    },
    active_page: {
      type: Number,
      default: 1
    },
    last_page: {
      type: Number,
      default: 3
    },
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_pagination() {
      return this.pagination.filter((el, index) => {
        return index > 0 && this.pagination.length > index + 1
      })
    },
    pagination_length() {
      return this.pagination.length
    },
    prev_link() {
      if (!this.get_pagination) return;
      return this.pagination[0]
    },
    next_link() {
      if (!this.get_pagination) return;
      return this.pagination[this.pagination_length - 1]
    }
  },
  methods: {
    fetchData(el) {
      if (!el.url) return
      let url_data = getQueryObj((new URL(el.url)).search)
      this.pageChange(Number(url_data ? url_data.page : 1))
    },
    pageChange(page) {
      if (1 > page || page > this.last_page) return
      this.$emit('pageChange', {
        page: page
      })
    }
  }
}
</script>
